import Model, { Request } from '../model'
import APIObject from '../object'
import Enum from '../enums'

import Service from './service'
import Tax from './tax'

export default class Pass extends Model {
  static modelName () {
    return 'pass'
  }

  objectID () {
    return this.idPass
  }

  relations () {
    return {
      cancelReservationBehaviour: { type: CancelReservationBehaviour },
      deleteReservationBehaviour: { type: DeleteReservationBehaviour },
      expiryMode: { type: ExpiryMode },
      options: { type: PassOptions },
      services: { type: PassService },
    }
  }

  get expires () {
    return this.expiryDays !== 0
  }

  set expires (value) {
    this.expiryDays = value ? 1 : 0
  }

  get isLimitedUse () {
    return this.numberOfUses !== 0
  }

  set isLimitedUse (value) {
    this.numberOfUses = value ? 1 : 0
  }

  get image () {
    if (this.hasImage) {
      return this.images?.square || this.imageUrls?.square
    }

    return null
  }

  get initials () {
    return this.name.charAt(0).toUpperCase()
  }

  addPhoto (image, options) {
    const url = `${this.constructor.modelBaseURL()}/${this.objectID()}/addPhoto`

    const formData = new FormData()
    formData.append('image', image)

    const request = Request.jsonPost(url, formData)
    request.options = options

    // return this.constructor.requestItem(request, Photo)

    return this.constructor.requestItem(request, this.constructor)
  }

  deletePhoto () {
    const url = `${this.constructor.modelBaseURL()}/${this.objectID()}/deletePhoto`

    return this.constructor.requestItem(Request.get(url), this.constructor)
  }
}

export class PassService extends Model {
  static modelName () {
    return 'passService'
  }

  objectID () {
    return this.idPassService
  }

  relations () {
    return {}
  }
}

export class PassOptions extends APIObject {
  relations () {
    return {
      services: { type: Service },
      taxes: { type: Tax },
    }
  }
}

export const ExpiryMode = new Enum({
  booking: { value: 1, description: 'pass.expiryModeBooking' },
  appointment: { value: 2, description: 'pass.expiryModeAppointment' },
})

export const CancelReservationBehaviour = new Enum({
  return: { value: 0, description: 'pass.returnPassUsage' },
  leave: { value: 1, description: 'pass.leavePassUsage' },
})

export const DeleteReservationBehaviour = new Enum({
  return: { value: 0, description: 'pass.returnPassUsage' },
  leave: { value: 1, description: 'pass.leavePassUsage' },
})
